import {
  faChildReaching,
  faHandHoldingMedical,
  faHouseUser,
  faPersonCane,
} from "@fortawesome/free-solid-svg-icons";
import {
  SectorCard,
  SectorCardContainer,
  SectorCardIcon,
  SectorCardText,
  SectorCardTitle,
  SectorContainer,
  SectorImage,
  SectorIntroTitle,
  SectorTitle,
} from "./SectorStyles";

function Sector() {
  return (
    <SectorContainer>
      <SectorImage src="/assets/bg.png" />
      <SectorIntroTitle>Sectoren</SectorIntroTitle>
      <SectorTitle>Better Work, Better Life!</SectorTitle>
      <SectorCardContainer>
        <SectorCard>
          <SectorCardIcon icon={faHouseUser} />
          <SectorCardTitle>GHZ</SectorCardTitle>
          <SectorCardText>
            Verleen zorg en ondersteuning aan mensen met een verstandelijke of
            lichamelijke beperking.
          </SectorCardText>
        </SectorCard>
        <SectorCard>
          <SectorCardIcon icon={faChildReaching} />
          <SectorCardTitle>Jeugdzorg</SectorCardTitle>
          <SectorCardText>
            Help kinderen en jongeren met begeleiding en zorg in moeilijke
            situaties.
          </SectorCardText>
        </SectorCard>
        <SectorCard>
          <SectorCardIcon icon={faHandHoldingMedical} />
          <SectorCardTitle>GGZ</SectorCardTitle>
          <SectorCardText>
            Specialist in geestelijke gezondheidszorg, toegepaste wetenschap die
            zich met de psychische gezondheid van mensen bezighoudt.
          </SectorCardText>
        </SectorCard>
        <SectorCard>
          <SectorCardIcon icon={faPersonCane} />
          <SectorCardTitle>VVT</SectorCardTitle>
          <SectorCardText>
            Verleen zorg aan ouderen en mensen die thuis ondersteuning nodig
            hebben.
          </SectorCardText>
        </SectorCard>
      </SectorCardContainer>
    </SectorContainer>
  );
}

export default Sector;
